import { SOURCES } from "@/lib/sources";
import type { CountySource } from "@/lib/states";
import { cn } from "@/lib/utils";

/**
 * The citation set beside a county rating: what the source says about this county, then
 * the source itself as a link. Small type, the way a field guide prints a reference under
 * an entry, so the rating is never on the page without its evidence.
 */
export function CountySourceLine({
  source,
  className,
}: {
  source: CountySource;
  className?: string;
}) {
  const ref = SOURCES[source.sourceId];
  return (
    <span className={cn("block text-sm leading-snug text-muted-foreground", className)}>
      {source.finding}{" "}
      {ref && (
        <a
          href={ref.url}
          target="_blank"
          rel="noopener noreferrer"
          className="link print-no-url whitespace-nowrap"
          title={ref.title}
        >
          {ref.short ?? ref.org}
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
      )}
    </span>
  );
}
